export default __webpack_public_path__ + "media/images/logo-sqr-ml-contrast-fef363337087cfbf9efac9e84f925b3b.png";